module.exports = __webpack_public_path__ + "static/assets/cf3cad327c35e2ab365ac6cd377c7f79.svg";